"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReducer = exports.createActions = void 0;
const createActions = (reducers) => {
    return Object.keys(reducers).reduce((acc, key) => {
        return { ...acc, [key]: (payload) => ({ type: key, payload }) };
    }, {});
};
exports.createActions = createActions;
const createReducer = (reducers) => {
    return (state, action) => {
        if (!action)
            return state;
        const reducer = reducers[action.type];
        if (reducer) {
            return reducer(state, action.payload);
        }
        return state;
    };
};
exports.createReducer = createReducer;
